"use client";

import Device from "@/components/device";
import { cn } from "@/lib/utils";
import type { PageModule } from "@/types/modules";
import { useInView } from "motion/react";
import { useRef, useState } from "react";

const PHONE_WIDTH = 348;
const PHONE_HEIGHT = 700;

export function ProductDevice({
  pages,
  scale = 0.6,
  autoAdvanceMs,
  className,
}: {
  pages: PageModule[];
  scale?: number;
  autoAdvanceMs?: number;
  className?: string;
}) {
  const frameRef = useRef<HTMLDivElement>(null);
  const inView = useInView(frameRef, { amount: 0.4 });
  const [interacted, setInteracted] = useState(false);
  const advanceMs =
    autoAdvanceMs && inView && !interacted ? autoAdvanceMs : undefined;

  return (
    <div
      ref={frameRef}
      className={cn("relative shrink-0", className)}
      style={{ width: PHONE_WIDTH * scale, height: PHONE_HEIGHT * scale }}
      onPointerDown={() => setInteracted(true)}
    >
      <div
        className="absolute top-0 left-0 h-175 w-87 origin-top-left"
        style={{ transform: `scale(${scale})` }}
      >
        <Device
          pages={pages}
          mode="interactive"
          splitting={false}
          autoAdvanceMs={advanceMs}
        />
      </div>
    </div>
  );
}
